// extracted by mini-css-extract-plugin
export default {"modal":"invite-others_modal__YzCzm"};